import Instance from "../../../../Axios";

// New Actions for the app

const GetOrcamentosTotalValor =
  (parceirosId, dataInicio, dataFim) => async (dispatch) => {
    await Instance()
      .get(`/energias/dashboard/pedidosPropostasTotal`, {
        params: { parceirosId, dataInicio, dataFim },
      })
      .then(({ data }) => {
        //   console.log(data);
        dispatch({
          type: "GET_PEDIDOS_PROPOSTAS_TOTAL",
          payload: data.yData[0].pedidosOrcTotal,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export default GetOrcamentosTotalValor;
